<template>
  <AppPageSection>
    <AppContainer>
      <div class="app-page-not-found-content">
        <slot>
          <p>We couldn't find the page you were looking for. This is either because:</p>
          <ul>
            <li>
              <p>There is an error in the URL entered into your web browser. Please check the URL and try again.</p>
            </li>
            <li>
              <p>The page you are looking for has been moved or deleted.</p>
            </li>
          </ul>
          <p>
            You can return to our homepage by
            <RouterLink class="redirect-link" :to="redirectTo" replace> clicking here</RouterLink>.
          </p>
        </slot>
      </div>
    </AppContainer>
  </AppPageSection>
</template>

<script>
import AppContainer from '@/components/AppContainer.vue';
import AppPageSection from '@/components/AppPageSection.vue';

export default {
  name: 'AppPageNotFoundContent',
  components: { AppPageSection, AppContainer },
  props: {
    redirectTo: {
      type: [String, Object],
      default: '/',
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-page-not-found-content {
  font-size: 18px;
  letter-spacing: 0.06em;
  color: vars.$c-dark-gray;
  line-height: 1.5;
  max-width: 720px;
  margin: 0 auto;

  p:not(:last-child) {
    margin-bottom: 10px;
  }

  .redirect-link {
    color: vars.$c-dark-gray;
    font-weight: 500;
    text-decoration: underline;
  }

  ul {
    margin: 18px 0;
    padding-left: 40px;

    li {
      p {
        margin: 10px 0;
      }
    }
  }
}
</style>
